import { render, staticRenderFns } from "./loc-type-cards.vue?vue&type=template&id=642c126c&scoped=true"
import script from "./loc-type-cards.vue?vue&type=script&lang=js"
export * from "./loc-type-cards.vue?vue&type=script&lang=js"
import style0 from "./loc-type-cards.vue?vue&type=style&index=0&id=642c126c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c126c",
  null
  
)

export default component.exports